import { Text as BriqCommonText } from '@briq/shared'

export type TextProps = BriqCommonText.TextProps

export const Text = BriqCommonText.Text
